import React from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import get from 'lodash/get';
import { useAlert } from 'react-alert';

import { signModalService } from '../../services/services';
import { setFavoriteListingIdToUserProfile } from '../../ducks/user.duck';
import { LISTING_TYPE__AIRPLANES } from '../../util/editListingHelpers';
import {
  $getConfigState,
  saveListingIds,
  $saveListingIdsState,
} from '../../ducks/SavedListings.duck';

import AddFavoritesButton from './AddFavoritesButton';
import WatchlistAlertContent from '../../components/AlertsContent/WatchlistAlertContent';

const AddFavoritesComponent = props => {
  const {
    listing,
    isAuthenticated,
    onUpdateProfile,
    deleteFromFavorites,
    className,
    showText,
    getConfigState,
    currentUser,
    onSavedListingIds,
    saveListingIdsState,
  } = props;

  const alert = useAlert();
  const listingId = listing?.id?.uuid;
  const favoriteListings = getConfigState.listingIds;
  const isFavorite = favoriteListings.includes(listingId);
  const listingType = get(listing, 'attributes.publicData.listingType', LISTING_TYPE__AIRPLANES);
  const authorId = get(listing, 'author.id.uuid', null);
  const currUserId = get(currentUser, 'id.uuid', null);

  const setListingIdToProfile = () => {
    if (saveListingIdsState.inProgress) {
      return;
    }
    onSavedListingIds(
      listingType,
      authorId,
      currUserId,
      listingId
    ).then(resp => {
      const alertContent = (
        <WatchlistAlertContent
          listingIds={resp}
          listingId={listingId}
        />
      );
      alert.show(alertContent);
    });
  };

  const handleClick = () => {
    if (!isAuthenticated) {
      signModalService.openSignContent({
        signModalParamsAddToFavorites: listingId,
        signModalParamsListingType: listingType,
        signModalParamsAuthorId: authorId,
      });
    } else {
      if (deleteFromFavorites) {
        deleteFromFavorites();
      } else {
        setListingIdToProfile();
      }
    }
  };

  return (
    <AddFavoritesButton
      isFavorite={isFavorite}
      showText={showText}
      className={className}
      onClick={handleClick}
    />
  );
};

const mapStateToProps = state => {
  const {
    currentUser,
  } = state.user;

  return {
    isAuthenticated: state.Auth.isAuthenticated,
    currentUser,
    getConfigState: $getConfigState(state),
    saveListingIdsState: $saveListingIdsState(state),
  };
};

const mapDispatchToProps = dispatch => ({
  onSavedListingIds: (lType, authorId, currUserId, listingId) =>
    dispatch(saveListingIds(lType, authorId, currUserId, listingId)),
  onUpdateProfile: (lType, authId, lId) => dispatch(setFavoriteListingIdToUserProfile(lType, authId, lId)),
});

const AddFavorites = compose(
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(AddFavoritesComponent);

export default AddFavorites;
